// eslint-disable-next-line no-shadow
export enum SidebarLinkIdentifiers {
    DATA = 1,
    FORMS = 2,
    ANALYTICS = 3,
    SURGEON_DASHBOARD = 4,
    EXPORTS =5,
    ACTIVITY = 6,
    MANAGE_USERS = 7,
    STUDY_SETTINGS = 8,

    USER_PROFILE = 9,
    NEW_STUDY = 10,

    NESTED_NEW_VIEW = 11,
    NESTED_ARCHIVE = 12,

    ACCOUNT_SETTINGS = 21,
    BILLING_SETTINGS = 22,
    LOG_OUT = 23
}
